
const ATTENDANCE_ACTIVITY = { 
    CLOCK_IN: 1, 
    CLOCK_OUT: 2 
};

const ATTENDANCE_ACTIVITY_VIEW = {
    TABLE_VIEW: 1,
    CALENDAR_VIEW: 2,
}
const LEAVE_MODES = {
    FULL_OR_MULTIPLE_LEAVE_MODE: 2,
  
}

const ATTENDANCE_TABLE_OPTIONS = {
    MONTHY : 1,
    WEEKLY: 2,
    CURRRENT_WEEK: 3,
}
  
const EMPLOYEE_ACCOUNT_STATUS = {
    ACTIVE: 1, 
    ONBOARDING: 2,
    ON_LEAVE: 3,
    PROBATIONARY: 4,
    OFF_BOARDING: 5,
    LONG_ABSENCE: 6,
    TERMINATED: 7,
    RESIGNED: 8,}
 export {
   ATTENDANCE_ACTIVITY,
   ATTENDANCE_ACTIVITY_VIEW,
   LEAVE_MODES,
   ATTENDANCE_TABLE_OPTIONS,
   EMPLOYEE_ACCOUNT_STATUS,
 };